import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const announcementSlice = createSlice({
  name: "AnnounceList",

  initialState: { empAnnounceData: [], annoucementLoader: false },
  reducers: {
    setEmpAnnounceData: (state: any, action: PayloadAction<any>) => {
      state.empAnnounceData = action.payload;
    },
    setEmpAnnounceDataLoader: (state: any, action: PayloadAction<any>) => {
      state.annoucementLoader = action.payload;
    },

    resetEmpAnnounceData: (state: any) => {
      state = [];
    },
  },
});

export const {
  setEmpAnnounceData,
  resetEmpAnnounceData,
  setEmpAnnounceDataLoader,
} = announcementSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default announcementSlice.reducer;
